import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchShippingUser = createAction(ACTION.FETCH_SHIPPING_USER.REQUEST);

export const fetchShippingUserSuggest = createAction(ACTION.FETCH_SHIPPING_USER_SUGGEST.REQUEST);